import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { LTime } from '@app/components/date/LTime';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';

export function VerifiedMatchesTable({
  data,
}: {
  data: auditReports.BcrMatchesReportVerifiedItemDto[];
}) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        createDateTimeColumn<auditReports.BcrMatchesReportVerifiedItemDto>($t, {
          id: 'match.datetime',
          accessor: (row) => (row.match as auditReports.MatchResultDto)?.datetime,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        }),
        createCustomIdColumn<auditReports.BcrMatchesReportVerifiedItemDto>($t, {
          id: 'match.customId',
          accessor: (row) => (row.match as auditReports.MatchResultDto)?.customId,
          enableColumnFilter: true,
          filterFn: 'contains',
        }),
        {
          id: 'bcrEntry.name',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.bcrName',
            defaultMessage: 'BCR Nombre',
          }),
          accessorFn: (row) => row.bcrEntry.name,
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
        {
          id: 'match.matchedSchedule',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.matchedSchedule',
            defaultMessage: 'Schedule',
          }),
          accessorFn: (row) => {
            const match = row.match as auditReports.MatchResultDto;
            return match?.matchedSchedule?.datetime || null;
          },
          Cell: ({ row }) => {
            const match = row.original.match as auditReports.MatchResultDto;
            const matchedSchedule = match?.matchedSchedule;
            if (matchedSchedule?.datetime) {
              return (
                <Chip
                  label={<LTime value={matchedSchedule.datetime} />}
                  size="small"
                  color="success"
                />
              );
            }
            return (
              <Chip
                label={$t({
                  id: 'audit.reportsScreen.bcrMatches.noSchedule',
                  defaultMessage: 'Sin schedule',
                })}
                size="small"
                color="warning"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
          size: 150,
        },
        {
          id: 'bcrEntry.datetime',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.bcrEntryDatetime',
            defaultMessage: 'BCR Entry Time',
          }),
          accessorFn: (row) => (row.bcrEntry?.datetime ? new Date(row.bcrEntry.datetime) : null),
          Cell: ({ row }) => {
            if (!row.original.bcrEntry?.datetime) return null;
            return (
              <Chip
                label={<LTime value={row.original.bcrEntry.datetime} showSeconds />}
                size="small"
                color="info"
                variant="outlined"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        },
      ]}
    />
  );
}
